export class GGReelSymbolName {
    public static readonly DEADWILD: string = "Z";
    public static readonly BOMB: string = "B";
}